import type {
  CaseDocument,
  Filing,
} from '@/modules/tools/bankruptcy/stores/types'
import { NeedMore } from '../NeedMore'
import { DocumentsManager } from './DocumentsManager'
import { PageBudget } from './PageBudget'

const UploadHint = ({ filing }: { filing: Filing }) => {
  if (filing.atPageLimit) {
    return (
      <>
        <span>
          This case is at its {filing.pageLimit}-page limit. Remove a file to
          add another.
        </span>
        <br />
        <NeedMore limit="pageCap" />
      </>
    )
  }
  if (filing.numberOfPages > 0) {
    return <>Add the rest of the petition packet or any exhibits as PDFs.</>
  }
  return <>Upload the petition packet and any exhibits as PDFs.</>
}

export const DocumentsSection = ({
  filing,
  documents,
}: {
  filing: Filing
  documents: CaseDocument[]
}) => (
  <section className="space-y-4">
    <div>
      <h2 className="font-semibold text-lg">
        Documents <PageBudget filing={filing} />
      </h2>
      <p className="text-muted-foreground text-sm">
        <UploadHint filing={filing} />
      </p>
    </div>
    <DocumentsManager filing={filing} documents={documents} />
  </section>
)
